export default __webpack_public_path__ + "static/media/all-media.ac8d02a4.svg";